<template>
<div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
        <v-layout row wrap justify-center>
            <v-flex xs12>
                <app-card>
                    <app-section-loader :status="loading.getList"></app-section-loader>
                    <v-card-title>
                        <v-layout row>
                            <v-flex auto class="pa-0">
                                <h4>BẢNG TÍNH TIỀN TRẢ CỌC</h4>
                            </v-flex>
                            <v-spacer></v-spacer>
                        </v-layout>
                        <v-layout row justify-end>
                            <v-flex xs12 md3>
                                <v-select
                                    label="Tòa nhà"
                                    :disabled="loading.submit"
                                    v-model="chosen_building"
                                    :items="list_building"
                                    prepend-icon="domain"
                                    required
                                    single-line
                                    hide-details
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field
                                v-model="search"
                                prepend-icon="search"
                                label="Tìm kiếm"
                                single-line
                                hide-details
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-select
                                    label="Tìm theo"
                                    :disabled="loading.submit"
                                    v-model="search_type"
                                    :items="list_search_type"
                                    prepend-icon="visibility"
                                    required
                                    single-line
                                    hide-details
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md3 class="pb-0">
                                <v-btn @click="getTablesData" color="primary" dark class="mt-3 mb-0">
                                    Tìm kiếm
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card class="mt-4">
                        <v-data-table
                            :headers="headers"
                            :items="items"
                            :rows-per-page-items="rowPerPage"
                            disable-initial-sort
                        >
                            <template #headers="props">
                                <tr>
                                    <th :class="`text-xs-${header.align} fw-bold`" v-for="header in props.headers" :key="header.text">
                                        {{ header.text }}
                                    </th>
                                </tr>
                            </template>
                        <template #items="props">
                            <tr>
                                <td class="text-center">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                class="ma-0"
                                                flat
                                                icon
                                                color="blue"
                                                v-on="on"
				                                @click="getReturnDepositDetail(props.item)"
                                                :loading="props.item.loading"
                                            >
                                                <v-icon class="zmdi zmdi-assignment"></v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Xem chi tiết hóa đơn tiền phòng</span>
                                    </v-tooltip>
                                </td>
                                <td class="text-center">{{ props.item.room_id }}</td>
                                <td class="text-center">
                                    <span :class="['v-badge', props.item.status ? 'primary' : '']">
                                        {{ props.item.status_text }}
                                    </span>
                                </td>
                                <td class="text-center text-no-wrap">{{ props.item.date_out | formatTimeServer }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.check_out_id }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.disbursement_id || props.item.additional_deposit_receipt_id }}</td>
                                <td class="text-center">{{ props.item.amount | formatNumber}}</td>
                                <td class="text-center">{{ props.item.total_deposit | formatNumber}}</td>
                                <td class="text-center">{{ props.item.room_price | formatNumber}}</td>
                                <td class="text-center">{{ props.item.total_bill | formatNumber}}</td>
                                <td class="text-center text-no-wrap">{{ props.item.debt_months && props.item.debt_months.length && props.item.debt_months.toString() || ''}}</td>
                                <td class="text-center text-no-wrap">{{ props.item.debt_amount | formatNumber}}</td>
                                <td class="text-center text-no-wrap">{{ props.item.fine_amount | formatNumber}}</td>
                                <td class="text-left text-no-wrap">{{ props.item.name }}</td>
                                <td class="text-left text-no-wrap">{{ props.item.phone }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.month_live }} tháng</td>
                                <td class="text-left text-no-wrap">{{ props.item.note }}</td>
                                <!-- <td class="text-center">{{ props.item.expense_amount | formatNumber}}</td> -->
                            </tr>
                        </template>
                        </v-data-table>
                    </v-card>
                </app-card>
            </v-flex>
        </v-layout>
    </v-container>
	<v-dialog v-if="dialogDetail" v-model="dialogDetail" max-width="fit-content">
        <app-card>
            <app-section-loader :status="loading.getDetail"></app-section-loader>
            <div class="text-right">
                <v-btn @click="print_portal = true" color="secondary" flat icon>
                    <v-icon class="zmdi zmdi-print"></v-icon>
                </v-btn>
                <v-btn
                    :disabled="user_role !== 'admin' && user_role !== 'manager'"
                    @click="calculateReturnDeposit(chosen_room_bill.room_id)"
                    color="secondary"
                    flat
                    icon
                >
					<v-icon class="zmdi zmdi-refresh"></v-icon>
				</v-btn>
				<v-btn v-if="is_refreshed" @click="updateReturnDeposit" color="primary">Lưu</v-btn>
            </div>
			<template v-if="chosen_return_deposit.computed_bill_paid_amount !== undefined">
                <return-deposit-bill-detail :bill="{...chosen_room_bill, ...chosen_return_deposit, last_month_payment: chosen_room_last_month_bill}"></return-deposit-bill-detail>
            </template>
            <template v-else>
                <return-deposit-bill-detail-old :bill="{...chosen_room_bill, ...chosen_return_deposit, last_month_payment: chosen_room_last_month_bill}"></return-deposit-bill-detail-old>
            </template>
        </app-card>
    </v-dialog>
	<print-portal :open="print_portal" @close="print_portal = false">
        <template v-if="chosen_return_deposit.computed_bill_paid_amount !== undefined">
            <return-deposit-bill-detail :bill="{...chosen_room_bill, ...chosen_return_deposit, last_month_payment: chosen_room_last_month_bill}"></return-deposit-bill-detail>
        </template>
        <template v-else>
            <return-deposit-bill-detail-old :bill="{...chosen_room_bill, ...chosen_return_deposit, last_month_payment: chosen_room_last_month_bill}"></return-deposit-bill-detail-old>
        </template>
	</print-portal>
</div>
</template>

<script>
import api from "Api";
import moment from 'moment'
import { buildParamQuery, deepCopy } from 'Helpers'
import { list_building } from 'Constants/db-config'
import ReturnDepositBillDetail from 'Components/Bill/ReturnDepositBillDetail'
import ReturnDepositBillDetailOld from 'Components/Bill/ReturnDepositBillDetailOld'
import PrintPortal from 'Components/Print/PrintPortal'
import { calculateRoomBill, getLastDateOfChosenMonth } from '../../functions'

export default {
    name: 'bang-tinh-tien-tra-coc',
    components: {
        ReturnDepositBillDetail,
        ReturnDepositBillDetailOld,
        PrintPortal
    },
    data() {
        return {
            search:'',
            search_type: 'roomId',
            headers: [
                { text: "Thao tác", align: "center", sortable: false, value: "room_id" },
                { text: "Số phòng", align: "center", sortable: false, value: "room_id" },
                { text: "Trạng thái", align: "center", sortable: false, value: "status" },
                { text: "Ngày trả", align: "center", value: "date_out" },
                { text: "Phiếu trả phòng", align: "center", value: "check_out_id" },
                { text: "Phiếu thu/chi", align: "center", value: "disbursement_id" },
                { text: "Tiền trả cọc", align: "center", value: "amount" },
                { text: "Tiền cọc", align: "center", value: "total_deposit" },
                { text: "Tiền phòng trả trước", align: "center", value: "room_price" },
                { text: "Hóa đơn", align: "center", value: "total_bill" },
                { text: "Tháng nợ", align: "center", value: "debt_months" },
                { text: "Tổng tiền nợ", align: "center", value: "debt_amount" },
                { text: "Tổng tiền phạt", align: "center", value: "debt_amount" },
                { text: "Tên", align: "left", value: "name" },
                { text: "SDT", align: "left", value: "phone" },
                { text: "Thời gian ở", align: "center", value: "month_live" },
                { text: "Ghi chú", align: "left", value: "note" },
                // { text: "Đã trả", align: "center", value: "expense_amount" },
            ],
            detail_headers: [
                { text: "Tên", align: "center", sortable: false, value: "name" },
                { text: "SDT", align: "center", sortable: false, value: "name" },
                { text: "Xe máy", align: "center", sortable: false, value: "motorbike" },
                { text: "Xe đạp", align: "center", sortable: false, value: "bike" }
            ],
            list_building: [
                ...list_building,
                {text: 'Tất cả', value: ''},
            ],
            list_search_type: [
                { text: 'Số phòng', value: 'roomId' },
                { text: 'Tên khách hàng', value: 'name' },
                { text: 'Biển số xe', value: 'motorbike' }
            ],
            chosen_building: '',
            items: [],
            loading: {
                submit: false,
                getDetail: false,
                getList: false
            },
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}],
            chosen_contract: {},
            menu_date_start: false,
            menu_date_end: false,
            date_start: moment().subtract(1,'months').startOf('month').format('YYYY-MM-DD'),
            date_end: moment().endOf('month').format('YYYY-MM-DD'),
            dialogDetail: false,
            chosen_room_bill: {},
            chosen_return_deposit: {},
            chosen_room_last_month_bill: {},
            print_portal: false,
            is_refreshed: false
        };
    },
    mounted() {
        this.getTablesData();
    },
    computed: {
        user_role(){
			return this.$store.state.auth.role
		},
    },
    methods: {
        getTablesData: async function () {
            this.loading.getList = true
            this.items = []
            const params = {
                building: this.chosen_building,
                [this.search_type]: this.search,
                // dateStart: this.date_start,
                // dateEnd: this.date_end,
            }
            const query = buildParamQuery(params)
            let data = await api.getListReturnDeposit(query)
            this.loading.getList = false
            if (data.status === 200 && data.data){
                this.items = data.data.map( receipt => {
                    receipt.status = !!receipt.disbursement_id || !!receipt.additional_deposit_receipt_id
                    if (receipt.status) {
                        if (!!receipt.disbursement_id) {
                            receipt.status_text = "Đã chi trả cọc";
                        } else if (!!receipt.additional_deposit_receipt_id) {
                            receipt.status_text = "Đã thu thêm tiền cọc";
                        }     
                    } else {
                        receipt.status_text = "";
                    }
                    receipt.loading = false;
                    return receipt
                })
            }
        },
        getReturnDepositDetail: async function(room){
            this.chosen_room_bill = {}
            this.chosen_room_last_month_bill = {}
            this.chosen_return_deposit = Object.assign({}, room)
            const params = {
                roomStateId: room.room_state_id,
                checkOutId: room.check_out_id
            }
            const query = buildParamQuery(params)

            const checkoutDate = new Date(room.date_out);
            checkoutDate.setMonth(checkoutDate.getMonth() - 1);
            const chosen_month = moment(checkoutDate.toISOString()).format("YYYY-MM")        
			const last_date_of_month = getLastDateOfChosenMonth(chosen_month);
            const paramsLastMonthBill = {
				lastDateOfMonth: last_date_of_month.clone().endOf("month").toISOString(),
				roomStateId: room.room_state_id,
            }
            const queryLastMonthBill = buildParamQuery(paramsLastMonthBill)
		    room.loading = true
            const promise_result = await Promise.all([
                api.getRoomCheckoutPayments(query),
                api.getChargeRoom(queryLastMonthBill)
            ])
            let data = promise_result[0]
            let dataLastMonthBill = promise_result[1]
		    room.loading = false

            if (data.status == 200 && data.data && data.data.length && dataLastMonthBill.status == 200){
                this.chosen_room_bill = data.data[0]
                if (dataLastMonthBill.data.paymentData[0]){
                    this.chosen_room_last_month_bill = dataLastMonthBill.data.paymentData[0];
                }
                this.dialogDetail = true
                this.is_refreshed = false
            } else {
                swal.fire("Lỗi", 'Không tìm thấy thông tin phiếu trả cọc', "error")
            }
        },
        calculateRoomDebt: function (room_debt){
            let debt = 0
            room_debt.data.forEach(payment => {
                if ( payment.collected_amount < payment.total_bill && !payment.is_approved ){
                    debt += payment.total_bill -  payment.collected_amount
                }
            })
            return debt
        },
        analyzeElectricWater: function (data, type, date_out){
            const arr = type == "E" ? data.electric : data.water
            const el_0 = arr[0]
            const month_check = el_0.date_check.substr(0, 7)
            const month_out = date_out.substr(0, 7)

            if (month_check == month_out && !el_0.check_in_id){
                return arr[1]
            } else return el_0
        },
        calculateReturnDeposit: async function (){
            this.loading.getDetail = true;


            const getCheckoutData = await api.getListCheckOut(`receiptId=${this.chosen_room_bill.check_out_id}`)
            const checkoutReceipt = getCheckoutData.data[0]

            console.log("🚀 ~ checkoutReceipt:", checkoutReceipt)
            
            // Tính tổng số tiền deposit
            const paramsReturnDeposit = {
                roomStateId: this.chosen_room_bill.room_state_id,
                checkOutDate: checkoutReceipt.date_out,
                isRefresh: true
            }

            const paramsDebtPayment = {
                roomStateId: this.chosen_room_bill.room_state_id,
                isDebt: true
            }

            const paramsRoomState = {
                roomStateId: this.chosen_room_bill.room_state_id,
                roomId: this.chosen_room_bill.room_id
            }

            const chosen_month = moment(checkoutReceipt.date_out).format("YYYY-MM")        
			const last_date_of_month = getLastDateOfChosenMonth(chosen_month);
            const paramsChargeRoom = {
				lastDateOfMonth: last_date_of_month.clone().endOf("month").toISOString(),
				roomId: this.chosen_room_bill.room_id,
				isRefresh: true
            }

            const queryReturnDeposit = buildParamQuery(paramsReturnDeposit)
            const queryDebtPayment = buildParamQuery(paramsDebtPayment)
            const queryRoomState = buildParamQuery(paramsRoomState)
            const queryChargeRoom = buildParamQuery(paramsChargeRoom)

			// Tính tiền phòng cho đến thời điểm hiện tại
            const promise_result = await Promise.all([
                api.getRoomDataForReturnDeposit(queryReturnDeposit),
                api.getRoomPayments(queryDebtPayment), 
                api.getTwoNewestRoomStateEachRoom(queryRoomState),
                api.getChargeRoom(queryChargeRoom)
            ]);

            const room_data = promise_result[0]
            
            const room_debt = promise_result[1]
            
            const room_state_data = promise_result[2].data[0]
            const room_state =
                room_state_data.old_room_state &&
                !room_state_data.old_room_state.room_state_id ===
                this.chosen_room_bill.room_state_id
                ? room_state_data.old_room_state
                : room_state_data.current_room_state;

            const charge_room = promise_result[3].data.paymentData[0]

			if (room_data.status == 200){
                const payment_data = room_data.data.paymentData[0]
                // payment_data.electric = [this.analyzeElectricWater(payment_data, "E", checkoutReceipt.date_out)]
                // payment_data.water = [this.analyzeElectricWater(payment_data, "W", checkoutReceipt.date_out)]

                const date_calc_room_bill = moment(checkoutReceipt.date_out).diff(moment(checkoutReceipt.date_schedule_out), 'days') > 0 ? checkoutReceipt.date_out : checkoutReceipt.date_schedule_out
                const internetResponse = await api.getListInternet();
                const allInternetUsers = internetResponse.status === 200 && internetResponse.data && internetResponse.data.internet 
					? internetResponse.data.internet 
					: null;
                // Lấy tất cả price history một lần
                let allPriceHistory = {};
                try {
                    const historyResponse = await api.getInternetPriceHistory();
                    if (historyResponse.status === 200 && historyResponse.data && historyResponse.data.data) {
                        // Group theo internet_id
                        historyResponse.data.data.forEach(history => {
                            const internetId = history.internet_id;
                            if (!allPriceHistory[internetId]) {
                                allPriceHistory[internetId] = [];
                            }
                            allPriceHistory[internetId].push(history);
                        });
                    }
                } catch (error) {
                    console.error('Lỗi lấy lịch sử giá:', error);
                }
                const room_payment = await calculateRoomBill(payment_data, checkoutReceipt.date_out.substr(0, 7), checkoutReceipt.date_out, date_calc_room_bill, true, 0, allInternetUsers, allPriceHistory)
                room_payment.date_out = room_payment.date_out || checkoutReceipt.date_out;
                    
                const deposits = room_state.deposits
                const total_deposit =  deposits.reduce(
                    (accu, deposit)=> accu += (Number(deposit.deposit_amount) || 0),
                0)

                // // Tính nợ
                // room_payment.debt_amount = this.calculateRoomDebt(room_debt)
                // room_payment.debt_months = []
                // room_payment.debt_details = []
                // room_debt.data.forEach(payment => {
                //     if ( payment.collected_amount < payment.total_bill && !payment.is_approved ) {
                //         room_payment.debt_months.push(payment.month)
                //         room_payment.debt_details.push({
                //             month: payment.month,
                //             debt_amount: payment.total_bill -  payment.collected_amount
                //         })
                //     }
                // })
                room_payment.deposit_amount = room_payment.deposit_status ? room_payment.deposit_price + room_payment.room_price : total_deposit
                console.log("🚀 ~ room_payment.deposit_amount:", room_payment.deposit_amount)
                room_payment.computed_amount = room_payment.deposit_amount - room_payment.debt_amount - room_payment.total_bill - room_payment.fine_amount
                console.log("🚀 ~ room_payment.fine_amount:", room_payment.fine_amount)
                console.log("🚀 ~ room_payment.total_bill:", room_payment.total_bill)
                console.log("🚀 ~ room_payment.debt_amount:", room_payment.debt_amount)
                console.log("🚀 ~ room_payment:", room_payment)
                room_payment.amount = room_payment.computed_amount
                // room_payment.other_fine_amount = 0;

                const new_return_deposit = deepCopy(room_payment)
                new_return_deposit.date_out = checkoutReceipt.date_out
                new_return_deposit.month = checkoutReceipt.date_out.substr(0, 7)
                new_return_deposit.total_deposit = total_deposit
                new_return_deposit.debt_amount = room_payment.debt_amount
                new_return_deposit.computed_room_price = new_return_deposit.room_price
                new_return_deposit.computed_total_bill = new_return_deposit.total_bill
                new_return_deposit.computed_total_deposit = new_return_deposit.total_deposit
                new_return_deposit.computed_deposit_price = new_return_deposit.deposit_price
                new_return_deposit.computed_fine_amount = new_return_deposit.fine_amount
                new_return_deposit.computed_fine_status_text = new_return_deposit.fine_status_text
                console.log("🚀 ~ chosen_room:", new_return_deposit)
                
                this.chosen_return_deposit = new_return_deposit
                this.chosen_room_bill = {...this.chosen_room_bill, ...charge_room}
                this.is_refreshed = true
                this.loading.getDetail = false;

			}
        },
        updateReturnDeposit: async function(){

			this.loading.getDetail = true

            const results = await Promise.all([
                api.updateReturnDeposit({
                    return_deposit: this.chosen_return_deposit
                }),
                api.updatePayment({
                    bill: this.chosen_room_bill
                })
            ])

            const data = results[0];
			this.loading.getDetail = false

			if (data.status == 200) {
				swal.fire("Thành công", data.data.message, "success")
                const updated_return_deposit = data.data.updated_return_deposit
                let found_return_deposit = this.items.find(item => item._id === updated_return_deposit._id)
                for (const key in updated_return_deposit) {
                    if (updated_return_deposit.hasOwnProperty(key)) {
                        found_return_deposit[key] = updated_return_deposit[key];
                    }
                }
				this.is_refreshed = false;
			} else swal.fire("Lỗi", data.message, "error")
        }
    }
};
</script>
